import { retriableLazyImport } from '@gcx-si/vue-components/retriableLazyImport'

import type { RouteRecordRaw } from 'vue-router'

import { constants } from '@/globals'

export default {
  path: 'cloud-adapters',
  meta: {
    navigation: {
      labelKey: 'app.cloud_adapters.pages.overview.title',
      targetName: constants.ROUTES_CLOUD_ADAPTERS,
    },
  },
  children: [
    {
      path: '',
      component: retriableLazyImport(() => import('./pages/Overview.vue')),
      name: constants.ROUTES_CLOUD_ADAPTERS,
      meta: {
        permission: {
          scope: 'read:cloud_adapter_config',
        },
      },
    },
    {
      path: ':cloudAdapterId',
      component: retriableLazyImport(() => import('./pages/Details.vue')),
      name: constants.ROUTES_CLOUD_ADAPTER,
      meta: {
        permission: {
          scope: 'read:cloud_adapter_config',
        },
      },
    },
    {
      path: 'create/:type(mqtt|http)',
      component: retriableLazyImport(() => import('./pages/Details.vue')),
      name: constants.ROUTES_CLOUD_ADAPTER_CREATE,
      meta: {
        permission: {
          scope: 'write:cloud_adapter_config',
        },
      },
    },
  ],
} as RouteRecordRaw
